module.exports = __webpack_public_path__ + "img/timestudy-4.efc6fa62.png";